import { asEnumValue } from "../../../../utils/enum";
import { InterviewAssistantEntryPoint } from "../../../graphql";

export type ImportMeetingParams = {
  integrationName: string;
  isInPerson: boolean;
  meetingUrl: string;
  botMeetingId: string | null;
  entryPoint: InterviewAssistantEntryPoint | null;
  forceImport: boolean;
  zoomMeetingId: string | null;
  inZoomApp: boolean;
  inTeamsApp: boolean;
};

export const parseMeetingDetails = (
  integrationName: string,
  searchParams: URLSearchParams
): Pick<
  ImportMeetingParams,
  "meetingUrl" | "botMeetingId" | "zoomMeetingId" | "entryPoint" | "forceImport"
> => {
  let meetingUrl = "";
  let botMeetingId: string | null = null;
  let zoomMeetingId: string | null = null;

  if (integrationName === "zoom") {
    meetingUrl = searchParams.get("joinUrl") ?? "";
    botMeetingId = searchParams.get("botMeetingId");
    try {
      zoomMeetingId = new URL(meetingUrl).pathname.split("/").pop() || "";
    } catch {
      /** `meetingUrl` is not a valid URL */
    }
  } else if (integrationName === "googleMeet") {
    meetingUrl =
      searchParams.get("googleMeetUrl") ??
      searchParams.get("googleMeetMeetingUrl") ??
      "";
    botMeetingId = searchParams.get("googleMeetMeetingId");
  } else if (integrationName === "teams") {
    meetingUrl =
      searchParams.get("teamsNotetakerUrl") ??
      searchParams.get("teamsNotetakerMeetingUrl") ??
      searchParams.get("joinUrl") ??
      "";
    botMeetingId =
      searchParams.get("teamsNotetakerMeetingId") ??
      searchParams.get("botMeetingId");
  }

  return {
    meetingUrl,
    botMeetingId,
    zoomMeetingId,
    entryPoint: asEnumValue(
      InterviewAssistantEntryPoint,
      searchParams.get("entryPoint")
    ),
    forceImport: searchParams.get("import") === "true",
  };
};

export const checkIsPmi = (zoomMeetingId: string | null): boolean => {
  // PMI is a meeting ID that is not a number
  return !!zoomMeetingId && /^\d+$/.test(zoomMeetingId) === false;
};
